var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningSignFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_833",
    "data-name": "Rectangle 833",
    width: 30,
    height: 30,
    transform: "translate(1103.797 993.566)",
    fill: "none",
    stroke: "#b7b5b6",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_72",
    "data-name": "Mask Group 72",
    transform: "translate(-1103.797 -993.566)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_11",
    "data-name": "Union 11",
    d: "M-3241.055,23013.645l10.823-18.689,10.818,18.689Zm2.559-1.473h0Z",
    transform: "translate(4349.03 -21995.734)",
    fill: "#a21110"
  }), /*#__PURE__*/React.createElement("path", {
    id: "warning_FILL0_wght400_GRAD0_opsz48",
    d: "M50.923,191.813a.7.7,0,0,0,.524-.213.726.726,0,0,0,.209-.529.7.7,0,0,0-.213-.524.726.726,0,0,0-.529-.209.7.7,0,0,0-.524.213.726.726,0,0,0-.209.529.7.7,0,0,0,.213.524A.726.726,0,0,0,50.923,191.813Zm-.742-2.73h1.476v-5.509H50.181ZM50.821,186.083Z",
    transform: "translate(1067.878 823.221)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningSignFilled);
export default __webpack_public_path__ + "static/media/warning-sign-filled.3c2021b37c3b0c9ab5a563854f9be29d.svg";
export { ForwardRef as ReactComponent };